export const SUB_TITLE_COLORS = [
  '#45A1CC',
  '#358561',
  '#A8831D',
  '#CC7B3D',
  '#DB6D78',
  '#AD7FF5',
  '#7068D1',
];
